module.exports = __webpack_public_path__ + "static/media/CancelIcon.c42c668b.svg";